// Business data for A Man With A Plan Handyman Services LLC
export const BUSINESS = {
  name: "A Man With A Plan",
  logo: "https://customer-assets-agu9un31.emergentagent.net/job_amwap-modern/artifacts/0tjshptb_AMWAP%20w%20background.png",
  legal: "A Man With A Plan Handyman Services LLC",
  short: "AMWAP",
  phone: "(843) 931-3040",
  phoneHref: "tel:+18439313040",
  email: "info@amwapservices.com",
  location: "North Charleston, South Carolina",
  area: "Charleston & the Lowcountry",
  rating: "5.0",
  reviewCount: "18",
  tagline: "Handyman Services You Can Trust",
  mission:
    "Our goal is to go out everyday and provide our clients with a professional handyman service, a positive attitude, and a peace of mind.",
  socials: {
    facebook: "https://www.facebook.com/amwapservices/",
    instagram: "https://www.instagram.com/amwaphandyman/",
    linkedin: "https://www.linkedin.com/company/a-man-with-a-plan-handyman-services-llc/",
    yelp: "https://www.yelp.com/biz/a-man-with-a-plan-handyman-services-llc-north-charleston",
  },
};

export const NAV = [
  { label: "Home", to: "/" },
  {
    label: "Our Services",
    to: "/services",
    children: [
      { label: "Residential Services", to: "/services#residential" },
      { label: "Facility Maintenance Solutions", to: "/services#facility" },
    ],
  },
  { label: "Gallery & Reviews", to: "/gallery" },
  { label: "AMWAP Supply", to: "/supply" },
  { label: "Contact Us", to: "/contact-us" },
];

export const IMAGES = {
  hero: "/hero.jpg",
  heroTools:
    "https://images.unsplash.com/photo-1783587354617-66b8b7c6a0cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHw0fHxoYW5keW1hbiUyMHRvb2xzJTIwd29ya2luZyUyMGhvbWUlMjByZXBhaXJ8ZW58MHx8fHwxNzg1MTE1MDgwfDA&ixlib=rb-4.1.0&q=85",
  drill:
    "https://images.unsplash.com/photo-1562259929-b4e1fd3aef09?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxoYW5keW1hbiUyMHRvb2xzJTIwd29ya2luZyUyMGhvbWUlMjByZXBhaXJ8ZW58MHx8fHwxNzg1MTE1MDgwfDA&ixlib=rb-4.1.0&q=85",
  caulk:
    "https://images.unsplash.com/photo-1607400201515-c2c41c07d307?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxoYW5keW1hbiUyMHRvb2xzJTIwd29ya2luZyUyMGhvbWUlMjByZXBhaXJ8ZW58MHx8fHwxNzg1MTE1MDgwfDA&ixlib=rb-4.1.0&q=85",
  flooring: "/flooring.jpg",
  tvMount:
    "https://images.unsplash.com/photo-1633604712918-6ab1173d0ecd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxUViUyMHdhbGwlMjBtb3VudGluZyUyMGluc3RhbGxhdGlvbnxlbnwwfHx8fDE3ODUxMTUwOTR8MA&ixlib=rb-4.1.0&q=85",
  tvMount2:
    "https://images.unsplash.com/photo-1586024486164-ce9b3d87e09f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHw0fHxUViUyMHdhbGwlMjBtb3VudGluZyUyMGluc3RhbGxhdGlvbnxlbnwwfHx8fDE3ODUxMTUwOTR8MA&ixlib=rb-4.1.0&q=85",
  fence: "/fence-v2.jpg",
  fence2: "/fence-detail.jpg",
  furniture:
    "https://images.unsplash.com/photo-1560185007-5f0bb1866cab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxmdXJuaXR1cmUlMjBhc3NlbWJseSUyMGhvbWV8ZW58MHx8fHwxNzg1MTE1MDk0fDA&ixlib=rb-4.1.0&q=85",
  deck:
    "https://images.unsplash.com/photo-1574120583586-de8847ae992c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxkZWNrJTIwYnVpbGRpbmclMjBjYXJwZW50cnl8ZW58MHx8fHwxNzg1MTE1MDQyfDA&ixlib=rb-4.1.0&q=85",
  porch:
    "https://customer-assets-agu9un31.emergentagent.net/job_amwap-modern/artifacts/xa4ct11j_Screened%20In%20Porch.webp",
  shed: "/storage-shed.jpg",
  precision:
    "https://customer-assets-agu9un31.emergentagent.net/job_amwap-modern/artifacts/w6jtxjd6_1000006195.jpg",
  sauna:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_cd0f3c83-e256-41ba-88be-d4e23676470c/artifacts/c4y1xag9_20240125_142706_IMG_1402.webp",
  backsplash:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_cd0f3c83-e256-41ba-88be-d4e23676470c/artifacts/j1xdzyur_20240619_150516_IMG_1814.webp",
  wallDecor:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_cd0f3c83-e256-41ba-88be-d4e23676470c/artifacts/cu1mc8pn_20241210_144628_IMG_2254.webp",
  playground:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_cd0f3c83-e256-41ba-88be-d4e23676470c/artifacts/mkyq33cf_20251124_140122_3018822780022887425.webp",
  honeyDo:
    "https://static.prod-images.emergentagent.com/jobs/eb4cc13b-6b1e-41e4-a2cd-e6e185ca09d0/images/50d003dad99d55ed60cbbfe3cb036f913c4a9e4907b72aa094fa1007e1462a09.jpeg",
  portrait:
    "https://images.unsplash.com/photo-1461938337379-4b537cd2db74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxtYW4lMjBoYW5keW1hbiUyMHBvcnRyYWl0JTIwc21pbGluZyUyMHVuaWZvcm18ZW58MHx8fHwxNzg1MTE1MDQyfDA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    slug: "general-handyman",
    title: "General Handyman",
    tagline: "Your honey-do list, handled.",
    desc:
      "From drywall patches and picture hanging to door adjustments and small repairs all over your home, we take care of the tasks that pile up — quickly and cleanly.",
    points: ["Repairs & maintenance", "Picture & shelf hanging", "Drywall & patching", "Odd jobs of every kind"],
    image: IMAGES.heroTools,
  },
  {
    slug: "tv-mounting",
    title: "T.V. Mounting",
    tagline: "Clean, level, cable-managed.",
    desc:
      "Professional flat-screen mounting on any wall type with tidy cable management. We show up on time and leave a spotless, gallery-worthy install.",
    points: ["Any wall type", "Cable concealment", "Soundbar & shelves", "Multiple TVs same day"],
    image: IMAGES.tvMount,
  },
  {
    slug: "furniture-assembly",
    title: "Furniture Assembly",
    tagline: "Flat-pack, fully built.",
    desc:
      "Beds, desks, wardrobes, play sets and more — assembled correctly the first time so you can skip the frustration and enjoy your space.",
    points: ["Flat-pack furniture", "Play sets & swings", "Office & storage", "Efficient & tidy"],
    image: IMAGES.furniture,
  },
  {
    slug: "storage-building-assembly",
    title: "Storage Building Assembly",
    tagline: "Built to last, on your schedule.",
    desc:
      "Sheds and storage buildings assembled on-site with precision, so you get durable extra space without the weekend headache.",
    points: ["Shed kits", "On-site build", "Leveled & secured", "Weatherproof finish"],
    image: IMAGES.shed,
  },
  {
    slug: "fence-installation",
    title: "Wood Fence Installation",
    tagline: "Privacy and curb appeal.",
    desc:
      "Custom wood fence installation and repair that adds privacy, security and value to your property — built straight, solid and beautiful.",
    points: ["Privacy fencing", "Post repair", "Gates & hardware", "Straight, solid builds"],
    image: IMAGES.fence,
  },
  {
    slug: "screened-porch",
    title: "Screened-In Porch",
    tagline: "Enjoy the Lowcountry, bug-free.",
    desc:
      "Screened-in porch and patio installation so you can enjoy Charleston evenings outdoors, comfortable and pest-free.",
    points: ["Porch screening", "Patio enclosures", "Framing & finishing", "Durable materials"],
    image: IMAGES.porch,
  },
];

export const FACILITY = [
  { title: "Preventive Maintenance", desc: "Scheduled upkeep that keeps your facility running smoothly and prevents costly breakdowns." },
  { title: "Commercial Repairs", desc: "Drywall, doors, fixtures, and general repairs for offices, retail, and rental properties." },
  { title: "Property Turnovers", desc: "Fast, thorough make-readies between tenants so units are rent-ready on time." },
  { title: "Punch-List Completion", desc: "We close out the final details on new builds and renovations — quickly and cleanly." },
  { title: "Emergency Call-Outs", desc: "Responsive support when something breaks and simply can't wait." },
  { title: "Recurring Service Plans", desc: "Ongoing handyman coverage tailored to your property or portfolio." },
];

export const BENEFITS = [
  "We work quickly and efficiently — without compromising quality.",
  "Flexible scheduling that fits around your life.",
  "Easy to reach and quick to respond.",
  "Open, honest communication from start to finish.",
  "Clear expectations on ability, time and cost.",
  "We never leave a job undone.",
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Quality that speaks for itself",
    body:
      "Our expertise lets us deliver top-notch work in less time — so when you call us, you know you're in good hands.",
  },
  {
    n: "02",
    title: "A positive attitude, every visit",
    body:
      "We show up with energy and respect. The work we do brings joy to our clients, and that's a chance to build a lasting relationship.",
  },
  {
    n: "03",
    title: "Trust brings peace",
    body:
      "By being reliable, honest and thorough, we earn your trust. No more lengthy honey-do lists — just more time with family and friends.",
  },
];

export const REVIEWS = [
  { name: "Melinda Hamilton", date: "March 2025", stars: 5, text: "Wow! Man with a Plan got more done here in an hour than any repair service I have worked with. Professional. Knowledgeable. Great work." },
  { name: "Austin Fraile", date: "July 2024", stars: 5, text: "Very knowledgeable, personable, professional, and attentive to all needs. Did an amazing job mounting our three TVs and all the other random requests we had!" },
  { name: "Kenny Wright", date: "June 2024", stars: 5, text: "Needed help with 3 TVs + 3 mirrors. A Man w/ a Plan showed up same day! Clean, precise work. Would recommend to my grandmama!!" },
  { name: "Rob Varner", date: "May 2024", stars: 5, text: "Anthony was INCREDIBLY helpful and professional, prompt and thorough. His prices were also incredibly reasonable. I cannot say enough wonderful things." },
  { name: "Ben Morgan", date: "March 2024", stars: 5, text: "Anthony and Robert were fantastic. Responsive, creative, great work. Will use them for all of our needs going forward." },
  { name: "Ryan Stavrakas", date: "March 2024", stars: 5, text: "Quick to reply. Fair pricing and quality work. Would absolutely use them again." },
  { name: "Apricot Lane Charleston", date: "March 2024", stars: 5, text: "Absolutely wonderful service! Will definitely become our regular handyman service — so quick, professional, and well priced!" },
  { name: "debby maxwell", date: "March 2024", stars: 5, text: "Anthony assembled a swing play set and was very efficient. He showed up on time and got straight to work. Very pleased with the outcome." },
  { name: "Julia Parrish", date: "March 2022", stars: 5, text: "I definitely recommend this service. I received a response within 2 hours. Incredibly professional and friendly. I will be calling again." },
];

export const GALLERY = [
  { src: IMAGES.fence, label: "Wood Fence Installation", span: "lg" },
  { src: IMAGES.tvMount, label: "TV Mounting", span: "sm" },
  { src: IMAGES.furniture, label: "Furniture Assembly", span: "sm" },
  { src: IMAGES.porch, label: "Screened-In Porch", span: "sm" },
  { src: IMAGES.sauna, label: "Sauna Assembly", span: "sm" },
  { src: IMAGES.flooring, label: "Flooring & Trim", span: "lg" },
  { src: IMAGES.tvMount2, label: "Clean Cable Management", span: "sm" },
  { src: IMAGES.fence2, label: "Privacy Fencing", span: "sm" },
  { src: IMAGES.precision, label: "Precision Installs", span: "sm" },
  { src: IMAGES.backsplash, label: "Custom Backsplash Installation", span: "sm" },
  { src: IMAGES.playground, label: "Commercial Playground Installation", span: "lg" },
  { src: IMAGES.wallDecor, label: "Precision Wall Decor Installation", span: "sm", fit: "contain" },
];

export const STORE = {
  packages: [
    { name: "Handyman Half-Day", price: "$250", unit: "up to 4 hrs · labor only", desc: "A block of focused hands-on time to knock out your list of small jobs.", tag: "Popular" },
    { name: "Handyman Full-Day", price: "$500", unit: "up to 8 hrs · labor only", desc: "A full day of work for bigger projects and long to-do lists.", tag: "Best value" },
    { name: "TV Mount Package", price: "from $250", unit: "2 TVs · labor only", desc: "Professional mount with cable management on any wall type.", tag: null },
    { name: "Furniture Assembly", price: "$215", unit: "3 hrs · labor only", desc: "Flat-pack furniture assembled correctly the first time.", tag: null },
  ],
  giftcards: [
    { name: "Gift Card", price: "$75", desc: "The perfect gift for new homeowners and busy families." },
    { name: "Gift Card", price: "$225", desc: "A generous head start on any home project." },
    { name: "Gift Card", price: "$500", desc: "Cover a full day of trusted handyman help." },
  ],
  merch: [
    { name: "AMWAP Tee", price: "$24", desc: "Soft cotton tee with the classic navy logo.", image: "https://static.prod-images.emergentagent.com/jobs/eb4cc13b-6b1e-41e4-a2cd-e6e185ca09d0/images/f1b97a6badd79339b15107a602e6b69ec6d7780e0b2365e319db48f73ac420de.jpeg" },
    { name: "AMWAP Cap", price: "$22", desc: "Structured cap for the job site or the ballgame.", image: "https://static.prod-images.emergentagent.com/jobs/eb4cc13b-6b1e-41e4-a2cd-e6e185ca09d0/images/9f08980fc7dfbe69a57d3ada832440f3f55521ede3721f1196b90dc56ec41882.jpeg" },
    { name: "AMWAP Duffel", price: "$65", desc: "Navy weekender duffel with leather trim and embroidered logo.", image: "https://static.prod-images.emergentagent.com/jobs/eb4cc13b-6b1e-41e4-a2cd-e6e185ca09d0/images/bb4d04afb59c780b770e10be2ae6c849c16b5c8fbc680b3850f9204e52d328f6.jpeg" },
  ],
};

